document.addEventListener('click', function (e) {
  const button = e.target.closest('#load-more-blog');
  if (!button) return;

  const container = document.querySelector('#blog-article-grid');
  const nextUrl = button.dataset.nextUrl;
  const currentPage = parseInt(button.dataset.page, 10);

  if (!container || !nextUrl) return;

  button.disabled = true;

  fetch(nextUrl)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newArticles = doc.querySelectorAll('#blog-article-grid .blog-list_list_item');
      const newButton = doc.querySelector('#load-more-blog');

      newArticles.forEach((card) => {
        container.appendChild(card);
      });

      button.dataset.page = currentPage + 1;

      if (!newButton) {
        button.remove();
      } else {
        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.disabled = false;
      }
    })
    .catch(() => {
      button.disabled = false;
    });
});
